import axios from "../../config/axiosConfig";
import { CREATE_MACHINE, GET_MACHINE, MACHINE_REQUEST, DELETE_MACHINE, UPDATE_MACHINE, MACHINE_REQUEST_FAILURE } from "../types";
import { addMasterInOption, updateMasterInOption } from "./master-options-actions";

export const getMachines = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MACHINE_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/machine/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_MACHINE, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MACHINE_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MACHINE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createMachine = (machine) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: MACHINE_REQUEST });
      return axios.post("/machine/add", machine,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_MACHINE, payload: response.data });
          dispatch(addMasterInOption('machines', response.data));
        } else {
          dispatch({
            type: MACHINE_REQUEST_FAILURE,
            error: "Machine create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MACHINE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MACHINE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateMachine = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MACHINE_REQUEST });
      const { auth } = getState();
      return axios.put("/machine/update", { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_MACHINE,
            payload: { id, data: response.data },
          });
          dispatch(updateMasterInOption('machines', id, response.data));
        } else {
          dispatch({
            type: MACHINE_REQUEST_FAILURE,
            error: "Machine update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MACHINE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MACHINE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteMachine = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: MACHINE_REQUEST });
      return axios.delete(`/machine/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_MACHINE, id: id });
          dispatch(updateMasterInOption('machines', id));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MACHINE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MACHINE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
